import { List } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../../App/Models/NotificationDuration';
import { AppService, DomainTypes, Types } from '../../../DomainTypes';
import LetterAuthorisationSignatory from '../../../Models/LetterAuthorisation/LetterAuthorisationSignatory';

export default class SignatoriesVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        public letterAuthorisationApiClient = AppService.get(DomainTypes.ApiClients.LetterAuthorisation),
        public imagesApiClient = AppService.get(DomainTypes.ApiClients.ImagesApiClient),
        private dataCache = AppService.get(DomainTypes.Services.DataCache)) {

        super(taskRunner);
        this.makeObservable();
    }

    public signatoryList = new List(LetterAuthorisationSignatory);

    public editingSignatory: LetterAuthorisationSignatory | null = null;

    public async initialise() {

        const data = await this.taskRunner.waitForData(this.letterAuthorisationApiClient.getSignatories());
        this.signatoryList.set(data);
    }

    public editSignatory(signatory?: LetterAuthorisationSignatory) {
        this.editingSignatory = signatory ?? new LetterAuthorisationSignatory();
    }

    public saveSignatory() {
        this.taskRunner.run(async () => {
            if (this.editingSignatory) {

                const response = await this.letterAuthorisationApiClient.saveSignatory(this.editingSignatory.toJSObject());
                this.signatoryList.update([response.data]);
                this.editingSignatory = null;
                this.dataCache.letterAuthorisationSignatories.expire();

                this.notifications.addSuccess("Saved", "Signatory saved successfully.", NotificationDuration.Standard);
            }
        })
    }
}